import * as React from "react";
import { Divider, Typography, Modal, Box, Button, TextField, FormControl, MenuItem, InputLabel, Select, IconButton, Autocomplete } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: '90%',
  overflowY: 'auto',
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "20px",
};

export default function NewModal({ exercicios, addFunction, loadingExercicios }) {

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const lightColor = "rgba(255, 255, 255, 0.7)";
  const [exercicio, setExercicio] = useState([])

  const handleOpen = () => {
    setExercicio([])
    setOpen(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const payload = {
      description: data.get("name"),
      exercises: exercicio,
    };

    console.log('handleSubmit no NewModal Treinos: ', payload)

    addFunction(payload);
    return handleClose();
  };

  const handleChange = (event, value) => {
    const selectedIds = value.map((exercise) => exercise.id);
    setExercicio(selectedIds);
  };

  return (
    <div>

      <Button variant="outlined" color="inherit" sx={{ borderColor: lightColor }} startIcon={<AddIcon />} onClick={handleOpen} spacing={2}>
        Adicionar
      </Button>

      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>

          <Typography id="modal-modal-title" variant="h6" component="h2" align="center">
            Adicionar Treino
          </Typography>
          <IconButton
            aria-label="fechar"
            size="medium"
            onClick={handleClose}
            style={{ position: "absolute", top: "10px", right: "10px" }}
          >
            X
          </IconButton>

          <Divider />

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }} align="center">

            <Box component="div" sx={{ mt: 1, mb: 4 }}>
              <TextField
                margin="normal"
                id="name"
                label="Nome"
                name="name"
                variant="standard"
                autoComplete="name"
                required
                fullWidth
                autoFocus
              />
            </Box>

            <Autocomplete
              multiple
              getOptionLabel={(option) => option.description}
              limitTags={2}
              options={exercicios}
              loading={loadingExercicios}
              disabled={loadingExercicios}
              defaultValue={[]}
              onChange={handleChange}
              size='small'
              noOptionsText={'Sem opções'}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Exercícios" placeholder="+ Exercicio"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingExercicios && <CircularProgress color="inherit" size={20} />}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 2, bgcolor: "primary.main" }}>
              Adicionar
            </Button>

          </Box>
        </Box>
      </Modal>
    </div>
  );
}